import { Pagination } from 'antd';
import React from 'react';
import { GeneralFunction } from 'types/common';

const PaginationComponent: React.FC<{
  loading?: boolean;
  onPageChange?: GeneralFunction;
  page?: number;
  total?: number;
}> = ({ loading, onPageChange, page, total }) =>
  !loading ? (
    <div
      className='gx-flex-column gx-justify-content-end gx-align-items-end gx-mt-2'
      style={{ paddingTop: 10, paddingLeft: 10 }}>
      <Pagination total={total || 0} defaultCurrent={page || 1} current={page} onChange={onPageChange} />
    </div>
  ) : null;

export default PaginationComponent;
